import MD5 from "js-md5";
import {Base64} from "js-base64";
import JSEncrypt from "jsencrypt";

/**
 * 加密解密 js*/

/**
 * md5 8 位
 * @param str 加密字符串
 * @param start  截取 开始
 * @param length 截取长度
 * @returns {string}
 */
export const md5_encrypt = (str,start= 8,length= 16) => {
    return MD5(str).substr(start, length).toUpperCase()
}

/**
 * base64 8 位
 * @param str 加密字符串
 * @returns {string}
 */
export const base64_encrypt = (str) => {
    return Base64.encode(str)
}
/**
 * base64 解密
 * @param str 解密字符
 * @returns {string}
 */
export const base64_decode = (str) => {
    return Base64.decode(str)
}


export const _rsa_publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
export const _rsa_privateKey =  'MIIBUwIBADANBgkqhkiG9w0BAQEFAASCAT0wggE5AgEAAkEA0vfvyTdGJkdbHkB8\n' +
     'mp0f3FE0GYP3AYPaJF7jUd1M0XxFSE2ceK3k2kw20YvQ09NJKk+OMjWQl9WitG9p\n' +
     'B6tSCQIDAQABAkA2SimBrWC2/wvauBuYqjCFwLvYiRYqZKThUS3MZlebXJiLB+Ue\n' +
     '/gUifAAKIg1avttUZsHBHrop4qfJCwAI0+YRAiEA+W3NK/RaXtnRqmoUUkb59zsZ\n' +
     'UBLpvZgQPfj1MhyHDz0CIQDYhsAhPJ3mgS64NbUZmGWuuNKp5coY2GIj/zYDMJp6\n' +
     'vQIgUueLFXv/eZ1ekgz2Oi67MNCk5jeTF2BurZqNLR3MSmUCIFT3Q6uHMtsB9Eha\n' +
     '4u7hS31tj1UWE+D+ADzp59MGnoftAiBeHT7gDMuqeJHPL4b+kC+gzV4FGTfhR9q3\n' +
     'tTbklZkD2A=='
/**
 * rsa 8 位
 * @param str 加密字符串
 * @returns {string}
 */
export const rsa_encrypt = (str) => {
    let jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(_rsa_publicKey)
    return jsEncrypt.encrypt(str)
}


/**
 * rsa 解密
 * @param str 解密字符
 * @returns {string}
 */
export const rsa_decode = (str) => {
    let jsEncrypt = new JSEncrypt();
    jsEncrypt.setPrivateKey(_rsa_privateKey)
    return jsEncrypt.decrypt(str)
}